export const services = [
  {
    id: 1,
    title: "Trademark Registration",
    subtitle: "Federal Protection",
    description: "Stop waiting. File your trademark with the USPTO now and lock down exclusive rights to your brand across all 50 states. Our attorneys handle everything — you just sign.",
    icon: "Shield",
    features: [
      "Full USPTO application & prosecution",
      "Licensed attorney-reviewed filing",
      "Office action defense included",
      "Federal registration certificate"
    ]
  },
  {
    id: 2,
    title: "Copyright Registration",
    subtitle: "Creative Protection",
    description: "Your content is being stolen right now. Register your creative works, product images, and digital assets before someone else claims them as their own.",
    icon: "FileText",
    features: [
      "US Copyright Office filing",
      "Digital asset & listing protection",
      "Official registration certificate",
      "Legal enforcement authority"
    ]
  },
  {
    id: 3,
    title: "Company Formation",
    subtitle: "LLC & Corp Setup",
    description: "No LLC means no protection. Get your business legally structured with proper formation, EIN registration, and state filings done in days, not weeks.",
    icon: "Building",
    features: [
      "LLC & Corporation formation",
      "EIN / Tax ID registration",
      "Registered agent service",
      "Operating agreement included"
    ]
  },
  {
    id: 4,
    title: "Trademark Search",
    subtitle: "Conflict Analysis",
    description: "Filing blind is a $350 gamble. Our comprehensive search scans USPTO, state registries, and common law sources to kill conflicts before they kill your application.",
    icon: "Search",
    features: [
      "Complete USPTO database scan",
      "State registry cross-check",
      "Common law usage analysis",
      "Detailed conflict report"
    ]
  },
  {
    id: 5,
    title: "Amazon Brand Registry",
    subtitle: "Seller Enrollment",
    description: "No trademark = no Brand Registry = no A+ Content = lost sales. Get enrolled fast with our combined trademark filing and Amazon enrollment service.",
    icon: "Package",
    features: [
      "Full Brand Registry enrollment",
      "Amazon-specific trademark filing",
      "A+ Content & Sponsored Brands",
      "IP protection tools activation"
    ],
    highlighted: true
  }
];

export const pricingPlans = [
  {
    id: 1,
    name: "Starter",
    price: "$45",
    federal: "+ Federal Filing Fee",
    recommended: false,
    features: [
      "Case review & evaluation",
      "USPTO application filing",
      "Basic trademark search",
      "State e-filing included",
      "Email status updates"
    ],
    note: "(USPTO govt. fee not included)",
    buttonText: "Start Now"
  },
  {
    id: 2,
    name: "Professional",
    price: "$149",
    federal: "+ Federal Filing Fee",
    recommended: false,
    features: [
      "Everything in Starter",
      "Direct-hit conflict search",
      "Trademark monitoring alerts",
      "Refusal risk assessment",
      "Priority email support",
      "Status dashboard access"
    ],
    note: "(USPTO govt. fee not included)",
    buttonText: "Go Professional"
  },
  {
    id: 3,
    name: "Business",
    price: "$299",
    federal: "+ Federal Filing Fee",
    recommended: true,
    features: [
      "Everything in Professional",
      "Comprehensive search report",
      "Dedicated case manager",
      "Office action response",
      "1-year trademark monitoring",
      "Full documentation package",
      "Phone & email support"
    ],
    note: "(USPTO govt. fee not included)",
    buttonText: "Best Value — Choose This"
  },
  {
    id: 4,
    name: "Enterprise",
    price: "$349",
    federal: "+ Federal Filing Fee",
    recommended: false,
    features: [
      "Everything in Business",
      "Full clearance search report",
      "Priority fast-track processing",
      "Cease & desist letter",
      "Trademark renewal reminder",
      "Multi-class filing support",
      "Dedicated attorney access",
      "Brand protection strategy"
    ],
    note: "(USPTO govt. fee not included)",
    buttonText: "Go Enterprise"
  }
];

export const workProcess = [
  {
    id: 1,
    step: "01",
    title: "Consultation & Search",
    description: "Tell us your brand. We assess your trademark registration needs, run a deep conflict search across USPTO databases, and map out the fastest path to approval."
  },
  {
    id: 2,
    step: "02",
    title: "Preparation & Filing",
    description: "Our attorneys build your application with precise classifications, specimens, and documentation — then file directly with the USPTO on your behalf."
  },
  {
    id: 3,
    step: "03",
    title: "Registered & Protected",
    description: "We handle all USPTO correspondence and office actions. Once approved, you get your federal trademark certificate and we set up monitoring to catch infringers."
  }
];

export const whyChooseUs = [
  {
    id: 1,
    title: "Licensed Trademark Attorneys",
    description: "Not paralegals. Not chatbots. Every filing is handled by a licensed trademark attorney who has done this thousands of times."
  },
  {
    id: 2,
    title: "Flat-Rate Pricing, Period",
    description: "You see the price, you pay the price. No hidden fees, no surprise invoices. Trademark registration starts at $45."
  },
  {
    id: 3,
    title: "Dedicated Case Manager",
    description: "One person owns your case from start to finish. Real updates, real answers, real accountability."
  },
  {
    id: 4,
    title: "98% Approval Rate",
    description: "Our filings get approved because we do the work upfront. Thorough searches, precise applications, zero shortcuts."
  },
  {
    id: 5,
    title: "Fast Response Time",
    description: "24-hour response guarantee. Questions answered, updates delivered, problems solved — the same business day."
  },
  {
    id: 6,
    title: "10,000+ Trademarks Filed",
    description: "A decade of experience protecting brands across every industry. We have seen every edge case and know how to win."
  }
];

export const benefits = [
  { title: "Stop Brand Theft", description: "Without Trademark Agency USA, anyone can copy your brand. Registration gives you the legal power to shut them down — immediately.", icon: "ShieldCheck" },
  { title: "50-State Protection", description: "Your trademark covers the entire United States. Not just your city, not just your state — everywhere.", icon: "Globe" },
  { title: "Win Legal Disputes", description: "Registered trademarks get priority in court, stronger remedies, and the ability to recover damages. Unregistered marks get nothing.", icon: "Zap" },
  { title: "Increase Brand Value", description: "A trademark is an asset on your balance sheet. It appreciates over time and makes your business more valuable for investors, buyers, and partners.", icon: "TrendingUp" },
  { title: "Use the Registered Symbol", description: "Only federally registered trademarks can use the official symbol. It signals legitimacy to customers, competitors, and potential infringers.", icon: "Award" },
  { title: "Permanent Protection", description: "Once registered, your trademark can be renewed indefinitely. Your brand stays protected for as long as you are in business.", icon: "Lock" }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah M.",
    role: "E-commerce Founder",
    content: "I was putting off trademark registration for months. Trademark Agency USA made it painless. Filed, approved, done. Should have done this on day one.",
    rating: 5
  },
  {
    id: 2,
    name: "Michael C.",
    role: "Startup CEO",
    content: "Their trademark search caught a conflict that would have killed my application. That one search saved me $350 in filing fees and 8 months of wasted time.",
    rating: 5
  },
  {
    id: 3,
    name: "Jennifer R.",
    role: "Online Seller",
    content: "Needed federal trademark protection fast. They filed my application, handled every step with the USPTO, and I had my registration certificate in hand. Seamless.",
    rating: 5
  },
  {
    id: 4,
    name: "David T.",
    role: "Brand Owner",
    content: "Someone was using a name almost identical to my brand. After trademark registration with these guys, I had the legal standing to send a cease and desist. Problem solved.",
    rating: 5
  },
  {
    id: 5,
    name: "Amanda S.",
    role: "Restaurant Owner",
    content: "The Business package was worth every dollar. Dedicated case manager, comprehensive search, office action handled. I did not have to worry about a single thing.",
    rating: 5
  },
  {
    id: 6,
    name: "Robert W.",
    role: "Online Retailer",
    content: "Started with the $45 Starter package. Best money I ever spent on my business. Federal trademark protection for less than a nice dinner out.",
    rating: 5
  }
];

export const faqs = [
  {
    id: 1,
    question: "What is trademark registration and why do I need it NOW?",
    answer: "Trademark registration secures exclusive legal rights to your brand name, logo, or slogan through the USPTO. Without it, anyone can use your brand. Every day without registration is a day your brand is unprotected. Competitors, counterfeiters, and copycats can legally exploit your brand identity. File now or risk losing what you have built."
  },
  {
    id: 2,
    question: "How long does trademark registration take?",
    answer: "8 to 12 months from filing to approval. USPTO examination starts within 3-4 months. Our attorneys handle every office action to keep the timeline moving. The sooner you file, the sooner you are protected — waiting only extends your exposure window."
  },
  {
    id: 3,
    question: "What does the $45 Starter package include?",
    answer: "Full case review, complete USPTO application filing, basic trademark search, and state e-filing. Federal filing fees ($250-$350 per class) are paid separately to the USPTO. No hidden charges, no surprise costs."
  },
  {
    id: 4,
    question: "Which package should I choose?",
    answer: "Business ($299) is our most popular for a reason. It includes a dedicated case manager, office action response, comprehensive search, and 1-year monitoring. If you are serious about protecting your brand, this is the package that covers everything."
  },
  {
    id: 5,
    question: "Is a trademark search worth it?",
    answer: "Absolutely. Filing without a search is gambling with your money and time. Our search scans USPTO databases, state registries, and common law sources. We catch conflicts before the USPTO does — saving you from rejection, delays, and lost filing fees."
  },
  {
    id: 6,
    question: "What types of trademarks can I register?",
    answer: "You can register brand names, logos, slogans, and even sounds or colors that identify your products or services. Our attorneys evaluate your mark during the free consultation and advise on the strongest filing strategy for your specific situation."
  },
  {
    id: 7,
    question: "What if my application gets rejected?",
    answer: "Our Business and Enterprise packages include office action response at no extra charge. We analyze the objection, prepare a strategic legal response, and resubmit within the deadline. Our 98% approval rate speaks for itself."
  },
  {
    id: 8,
    question: "What are USPTO filing fees?",
    answer: "Government filing fees are $250-$350 per trademark class, paid directly to the USPTO. These are required and non-refundable. Our service fees are separate and clearly listed — no hidden costs, no billing surprises."
  }
];

export const countryCodes = [
  { code: '+1', country: 'US/Canada', flag: '\u{1f1fa}\u{1f1f8}' },
  { code: '+44', country: 'UK', flag: '\u{1f1ec}\u{1f1e7}' },
  { code: '+91', country: 'India', flag: '\u{1f1ee}\u{1f1f3}' },
  { code: '+86', country: 'China', flag: '\u{1f1e8}\u{1f1f3}' },
  { code: '+81', country: 'Japan', flag: '\u{1f1ef}\u{1f1f5}' },
  { code: '+49', country: 'Germany', flag: '\u{1f1e9}\u{1f1ea}' },
  { code: '+33', country: 'France', flag: '\u{1f1eb}\u{1f1f7}' },
  { code: '+39', country: 'Italy', flag: '\u{1f1ee}\u{1f1f9}' },
  { code: '+61', country: 'Australia', flag: '\u{1f1e6}\u{1f1fa}' },
  { code: '+55', country: 'Brazil', flag: '\u{1f1e7}\u{1f1f7}' },
  { code: '+52', country: 'Mexico', flag: '\u{1f1f2}\u{1f1fd}' },
  { code: '+82', country: 'South Korea', flag: '\u{1f1f0}\u{1f1f7}' },
  { code: '+34', country: 'Spain', flag: '\u{1f1ea}\u{1f1f8}' },
  { code: '+31', country: 'Netherlands', flag: '\u{1f1f3}\u{1f1f1}' },
  { code: '+65', country: 'Singapore', flag: '\u{1f1f8}\u{1f1ec}' },
  { code: '+971', country: 'UAE', flag: '\u{1f1e6}\u{1f1ea}' },
  { code: '+92', country: 'Pakistan', flag: '\u{1f1f5}\u{1f1f0}' },
  { code: '+62', country: 'Indonesia', flag: '\u{1f1ee}\u{1f1e9}' },
  { code: '+63', country: 'Philippines', flag: '\u{1f1f5}\u{1f1ed}' },
  { code: '+60', country: 'Malaysia', flag: '\u{1f1f2}\u{1f1fe}' },
  { code: '+966', country: 'Saudi Arabia', flag: '\u{1f1f8}\u{1f1e6}' },
  { code: '+27', country: 'South Africa', flag: '\u{1f1ff}\u{1f1e6}' },
  { code: '+234', country: 'Nigeria', flag: '\u{1f1f3}\u{1f1ec}' },
  { code: '+20', country: 'Egypt', flag: '\u{1f1ea}\u{1f1ec}' },
  { code: '+90', country: 'Turkey', flag: '\u{1f1f9}\u{1f1f7}' },
  { code: '+880', country: 'Bangladesh', flag: '\u{1f1e7}\u{1f1e9}' },
  { code: '+353', country: 'Ireland', flag: '\u{1f1ee}\u{1f1ea}' },
  { code: '+48', country: 'Poland', flag: '\u{1f1f5}\u{1f1f1}' },
  { code: '+64', country: 'New Zealand', flag: '\u{1f1f3}\u{1f1ff}' },
  { code: '+972', country: 'Israel', flag: '\u{1f1ee}\u{1f1f1}' },
];
